/* eslint-disable jsx-a11y/img-redundant-alt */
import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import AddAPhotoIcon from '@material-ui/icons/AddAPhoto';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import Typography from '@material-ui/core/Typography';
import DeleteOutlinedIcon from '@material-ui/icons/DeleteOutlined';
import { mainColor, UNIT } from '../../constants/theme';
import Paper from '../Paper';
import Switch from '../Switch';
import Spinner from '../Spinner';
import IconButton from '../IconButton';
import { checkAccess } from '../../utils/admins';
import { isStringNotNull, isIntegerNotNull, isFloatNotNull, displayPriceFormat } from '../../utils/tools';
import { styles } from './CardItem.styles';
import { getMinimumPriceFreeProduct } from '../ProductList/ProductList.services';
import copyIcon from '../../assets/pictures/copyIcon.svg';
import { checkIntegrationAccess, hasExternalIntegration } from 'src/utils/externalIntegration';
const INITIAL_STATE = {
  disabledSwitch: false,
  anchorEl: null
};
const ITEM_HEIGHT = 48;
class CardItem extends React.Component {
  constructor() {
    super();
    this.state = INITIAL_STATE;
  }

  onChangeSwitch = async () => {
    const { onChange } = this.props;
    const { disabledSwitch } = this.state;
    if (!disabledSwitch) {
      this.setState({ disabledSwitch: true });
      await onChange();
      this.setState({ disabledSwitch: false });
    }
  };

  handleClick = event => {
    this.setState({ anchorEl: event.currentTarget });
  };

  handleClose = () => {
    this.setState({ anchorEl: null });
  };

  render() {
    const {
      onClick,
      classes,
      onRemove,
      onDuplicate,
      isLoadingProduct,
      item,
      body,
      index,
      className,
      isProduct,
      hideSuppression
    } = this.props;
    const { anchorEl } = this.state;
    const { description = '', price = '', name = '', disabled = false, image = null } = item;
    const open = Boolean(anchorEl);
    return (
      <Paper
        key={index}
        className={className || classes.paper}
        onClick={event => {
          event.preventDefault();
          event.stopPropagation();
          onClick();
        }}
        style={{
          backgroundColor: disabled && 'rgba(0, 0, 0, 0.2)'
        }}
      >
        {(checkAccess('features', 'productAndOption') && (checkIntegrationAccess('products', 'displayMenu') || !hasExternalIntegration())) && (
          <div>
            <IconButton
              className={classes.arroundIcon}
              aria-label='more'
              aria-controls='long-menu'
              aria-haspopup='true'
              onClick={event => {
                event.preventDefault();
                event.stopPropagation();
                this.handleClick(event);
              }}
            >
              <MoreVertIcon className={classes.icon} />
            </IconButton>
            <Menu
              id='long-menu'
              anchorEl={anchorEl}
              keepMounted
              open={open}
              onClose={event => {
                event.preventDefault();
                event.stopPropagation();
                this.handleClose(event);
              }}
              PaperProps={{
                style: {
                  maxHeight: ITEM_HEIGHT * 4.5,
                  width: '20ch',
                  borderRadius: UNIT * 0.5625
                }
              }}
            >
              <MenuItem
                onClick={event => {
                  event.preventDefault();
                  event.stopPropagation();
                  onDuplicate();
                  this.setState({ anchorEl: false });
                }}
              >
                <img src={copyIcon} alt='display image' style={{ width: `${UNIT * 0.9375}px` }} />
                <Typography
                  variant='inherit'
                  style={{ marginLeft: UNIT, fontSize: '14px!important' }}
                >
                  Dupliquer
                </Typography>
              </MenuItem>
              {!hideSuppression && <MenuItem
                onClick={event => {
                  event.preventDefault();
                  event.stopPropagation();
                  onRemove();
                  this.setState({ anchorEl: false });
                }}
              >
                <DeleteOutlinedIcon fontSize='small' />
                <Typography
                  variant='inherit'
                  style={{ marginLeft: UNIT * 0.6875, fontSize: '14px!important' }}
                >
                  Supprimer
                </Typography>
              </MenuItem>}

            </Menu>
          </div>
        )}
        <div className={classes.cardContent}>
          {isLoadingProduct ? (
            <div className={classes.card}>
              <Spinner className={classes.progress} />
            </div>
          ) : (
            isProduct && (
              <div
                className={classes.card}
                style={{
                  border: !image && '1px solid #dcdcdc40',
                  pointerEvents: 'none'
                }}
              >
                {image ? (
                  <img
                    style={{
                      borderTopLeftRadius: UNIT,
                      borderTopRightRadius: UNIT,
                      opacity: disabled && 0.5
                    }}
                    src={image}
                    alt='display image'
                  />
                ) : (
                  <div className='d-flex flex-column justify-content-center align-items-center'>
                    <AddAPhotoIcon className={classes.noImageIcon} />
                    <p className={classes.mediaStyle}>Ajouter une image</p>
                  </div>
                )}
              </div>
            )
          )}
          <p className={classes.textTitle}>{name}</p>
          <hr className={classes.hrStyle} />

          {isProduct && (
            <p className={classes.descriptionStyle}>{isStringNotNull(description) || '--'}</p>
          )}
          <p
            className={classes.priceFormat}
            style={{
              fontStyle: !isIntegerNotNull(price) && isProduct && 'italic',
              color: mainColor.secondaryColor
            }}
          >
            {isFloatNotNull(price)
              ? displayPriceFormat(price)
              : isProduct
                ? `À partir de ${getMinimumPriceFreeProduct(item)}`
                : 'Gratuit'}
          </p>
          {body}
          {isProduct && (
            <Switch
              checked={!disabled}
              onClick={event => event.stopPropagation()}
              onChange={this.onChangeSwitch}
              inputProps={{
                'aria-label': 'primary checkbox'
              }}
            />
          )}
        </div>
      </Paper>
    );
  }
}
export default withStyles(styles)(CardItem);
